import { Star } from 'lucide-react'

export function RewardAnimation({ message = '太棒了！', awarded = true }: { message?: string; awarded?: boolean }) {
  return (
    <div className="pointer-events-none fixed inset-0 z-50 grid place-items-center bg-garden-900/10 backdrop-blur-[2px]" role="status" aria-live="polite">
      <div className="animate-bounce-soft rounded-4xl bg-white px-10 py-8 text-center shadow-soft">
        <Star className="mx-auto mb-3 h-16 w-16 animate-star-pop fill-sun text-[#d89f19]" />
        <p className="text-2xl font-black text-ink">{message}</p>
        <p className="mt-1 font-bold text-garden-700">{awarded ? '+1 星星' : '又练好了一次'}</p>
      </div>
    </div>
  )
}
